import dayjs from '@/services/date'

// #region Helpers
function getBooleanOrderWeight(value) {
  const [WEIGHT_FALSE, WEIGHT_NULL, WEIGHT_TRUE] = [0, 1, 2]

  if (value === null || value === undefined) return WEIGHT_NULL
  return value ? WEIGHT_TRUE : WEIGHT_FALSE
}

function normalizeString(value) {
  return (value ?? 'Unknown')
    .toString()
    .toLowerCase()
    .replace(/[\s\-_.]+/g, '') // Remove whitespace, hyphens, underscores, dots
    .replace(/[^\w]/g, '') // Remove any remaining non-alphanumeric characters
}
// #endregion

// #region Exports
export const SORT_LATER = 1
export const SORT_EARLIER = -1
export const SORT_EQUAL = 0

export const sortMethodMap = Object.freeze({
  string: compareAscString,
  number: compareAscNumber,
  date: compareAscDate,
  booleanWeighted: compareAscBooleanByWeight,
})

export function compareAscString(rawA, rawB) {
  const a = normalizeString(rawA)
  const b = normalizeString(rawB)

  const aEmpty = a === ''
  const bEmpty = b === ''
  if (aEmpty && bEmpty) return SORT_EQUAL
  if (aEmpty && !bEmpty) return SORT_LATER
  if (!aEmpty && bEmpty) return SORT_EARLIER

  if (a < b) return SORT_EARLIER
  if (a > b) return SORT_LATER
  return SORT_EQUAL
}

export function compareAscDate(a, b) {
  const da = dayjs(a)
  const db = dayjs(b)
  if (da.isBefore(db)) return SORT_EARLIER
  if (da.isAfter(db)) return SORT_LATER
  return SORT_EQUAL
}

export function compareAscNumber(a, b, defaultValue = 0) {
  const numA = isNaN(a) ? defaultValue : Number(a)
  const numB = isNaN(b) ? defaultValue : Number(b)

  const diff = numA - numB

  if (diff === 0) return SORT_EQUAL

  return diff < 0 ? SORT_EARLIER : SORT_LATER
}

export function compareAscBooleanByWeight(a, b) {
  const diff = getBooleanOrderWeight(a) - getBooleanOrderWeight(b)
  return diff === 0 ? SORT_EQUAL : diff < 0 ? SORT_EARLIER : SORT_LATER
}
// #endregion
